import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { glb_sv } from 'src/utils';
import { useState } from 'react';
import { useEffect } from 'react';

export default function ComboBox({
    id,
    getValue,
    sizeCbb = 'small',
    valueSelect = undefined,
    multiple = false,
    helperText = '',
    error = false,
    label,
    selectOption = [],
    displayLabel = 'label',
    valueEqual = 'value',
    disabled = false,
    required = false,
    fullWidth = true,
}) {
    const [value, setValue] = useState(null);

    useEffect(() => {
        if (valueSelect === undefined) return;

        if (valueSelect !== null && valueSelect !== undefined) {
            const found = selectOption.find(
                (opt) =>
                    opt[valueEqual] === valueSelect ||
                    opt === valueSelect ||
                    (typeof valueSelect === 'object' && opt[valueEqual] === valueSelect[valueEqual])
            );
            setValue(found || null);
        } else {
            setValue(null);
        }
    }, [valueSelect, selectOption, valueEqual]);

    const handleOnChange = (event, value) => {
        setValue(value);
        getValue && getValue(value);
    };

    return (
        <Autocomplete
            id={id}
            // multiple
            fullWidth={fullWidth}
            options={selectOption}
            disabled={disabled}
            size={sizeCbb}
            value={value}
            autoHighlight
            getOptionLabel={(selectOption) =>
                selectOption[displayLabel] ? glb_sv.convertMultipleLanguages(selectOption[displayLabel]) : ''
            }
            isOptionEqualToValue={(option, value) =>
                value ? option[valueEqual] === value[valueEqual] : option === value
            }
            onChange={handleOnChange}
            renderOption={(props, option) => (
                <li {...props} key={option[valueEqual]}>
                    {glb_sv.convertMultipleLanguages(option[displayLabel])}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    // size={sizeCbb}
                    label={glb_sv.convertMultipleLanguages(label)}
                    error={error}
                    helperText={helperText}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                    required={required}
                />
            )}
        />
    );
}
